"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GIVEAWAY_POOLING_TIME_MS = exports.SteamErrorCode = exports.EntryFailureCode = exports.giveawayAnalyticsEvents = exports.VerifySteamStage = exports.giveawayEndpointIds = void 0;
exports.giveawayEndpointIds = {
    CREATE_GIVEAWAY: 'CREATE_GIVEAWAY',
    CREATE_GIVEAWAY_ENTRY: 'CREATE_GIVEAWAY_ENTRY',
    CREATE_GIVEAWAY_ENTRY_CALLBACK: 'CREATE_GIVEAWAY_ENTRY_CALLBACK',
    GIVEAWAYS_RESOLVE: 'GIVEAWAYS_RESOLVE',
    REDEEM_REWARD: 'REDEEM_REWARD',
    ENTER_GIVEAWAY: 'ENTER_GIVEAWAY',
    GET_USER_GIVEAWAYS: 'GET_USER_GIVEAWAYS',
    GET_USER_GIVEAWAY_REWARDS: 'GET_USER_GIVEAWAY_REWARDS',
    GET_GIVEAWAY: 'GET_GIVEAWAY',
    IS_GIVEAWAY_ACTION_DONE: 'IS_GIVEAWAY_ACTION_DONE',
    SEND_GIVEAWAY_SUMMARIES: 'SEND_GIVEAWAY_SUMMARIES',
    SAVE_GIVEAWAY_TERMS: 'SAVE_GIVEAWAY_TERMS',
    GET_USER_GIVEAWAY_TERMS: 'GET_USER_GIVEAWAY_TERMS',
    GET_USER_VOUCHERS: 'GET_USER_VOUCHERS',
    GET_USER_GIVEAWAY_STATISTICS: 'GET_USER_GIVEAWAY_STATISTICS',
    GET_VOUCHERS_COUNT: 'GET_VOUCHERS_COUNT',
};
var VerifySteamStage;
(function (VerifySteamStage) {
    VerifySteamStage["SIGN_IN"] = "SIGN_IN";
    VerifySteamStage["SUCCESS"] = "SUCCESS";
    VerifySteamStage["ERROR"] = "ERROR";
})(VerifySteamStage || (exports.VerifySteamStage = VerifySteamStage = {}));
exports.giveawayAnalyticsEvents = {
    CREATE_GIVEAWAY: 'create_giveaway',
    SUBMIT_STEAM_ENTRY: 'submit_steam_entry',
    SUBMIT_STEAM_ENTRY_SUCCESS: 'submit_steam_entry_success',
    SUBMIT_ENTER_GIVEAWAY: 'submit_enter_giveaway',
    SUBMIT_ENTRY_TWITCH: 'submit_entry_twitch',
    SUBMIT_ENTRY_YOUTUBE: 'submit_entry_youtube',
    SUBMIT_ENTRY_TWITCH_SUCCESS: 'submit_entry_twitch_success',
    SUBMIT_ENTRY_YOUTUBE_SUCCESS: 'submit_entry_youtube_success',
    REDEEM_VOUCHER: 'redeem_voucher',
};
var EntryFailureCode;
(function (EntryFailureCode) {
    EntryFailureCode["NOT_CONNECTED_ACCOUNT"] = "NOT_CONNECTED_ACCOUNT";
    EntryFailureCode["NOT_FOLLOWING"] = "NOT_FOLLOWING";
    EntryFailureCode["EXTERNAL_ERROR"] = "EXTERNAL_ERROR";
})(EntryFailureCode || (exports.EntryFailureCode = EntryFailureCode = {}));
var SteamErrorCode;
(function (SteamErrorCode) {
    SteamErrorCode["ProfileNotPublic"] = "ProfileNotPublic";
})(SteamErrorCode || (exports.SteamErrorCode = SteamErrorCode = {}));
exports.GIVEAWAY_POOLING_TIME_MS = 10000;
